import { useNavigate, useParams } from "react-router"
import DashboardHeader from "../DashboardHeader";
import ReactQuill from "react-quill";
import { useEffect, useState } from "react";
import { removeHtmlTags } from "./AddNotification";
import { LuCheck } from "react-icons/lu";
import { useGetTemplateByIdQuery, useUpdateTemplateMutation } from "../../store/services/notificationTemplatesServices";
import { useDispatch } from "react-redux";
import { openModalWithTimeout } from "../../store/alertSlice";

export default function EditNotificationTemplate() {

    const { id } = useParams()
    const [template, setTemplate] = useState({
        title: '',
        body: ''
    })
    const [errors, setErrors] = useState({})
    const navigate = useNavigate()
    const dispatch = useDispatch()

    // const { data } = useGetTemplateByIdQuery();
    // const [updateTemplate] = useUpdateTemplateMutation()

    // useEffect(() => {
    //     if (data) {
    //         setTemplate(data)
    //     }
    // }, [data])

    const handleTemplateEdit = (e) => {
        setTemplate({ ...template, [e.target.id]: e.target.value })
    }

    const handleEditTemplateSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            try {
                const formData = new FormData();
                Object.keys(template).forEach((key) => formData.append(key, template[key]));
                // const result = await updateBlog({ data: formData, id: id }).unwrap();
                // console.log('Item updated:', result);
                navigate('/notifications/templates')
                dispatch(openModalWithTimeout({ text: 'Template successfully updated', type: 'success' }, 3000))
            } catch (error) {
                console.error('Failed to update item:', error);
            }
        }
        else {
            console.log("errors")
        }
    }

    const buttons = [
        { label: 'Cancel', color: 'bg-white', border: 'border border-b-2', icon: null, shadow: null, onClick: null, linkTo: "/notifications/templates" },
        {
            label: 'Save',
            icon: <LuCheck />,
            color: 'bg-primary text-white',
            border: 'border border-b-2 border-primary',
            shadow: 'shadow-md',
            linkTo: null,
            onClick: handleEditTemplateSubmit,
        }

    ]

    const details = {
        title: "Edit notification template",
    };

    const validateForm = () => {
        let formErrors = {};
        if (!template.title) formErrors.title = "Title is required";
        if (!template.body) formErrors.text = "Body is required";

        setErrors(formErrors);

        return Object.keys(formErrors).length === 0;
    };

    return (
        <>
            <DashboardHeader details={details} buttons={buttons} />
            <hr />
            <div className="bg-[#F9FAFB] rounded-b-xl">
                <hr />
                <div className="p-6 rounded-b-xl text-sm">
                    <form>
                        <div className="flex flex-col gap-4">
                            <div className="w-full">
                                <div>
                                    <label htmlFor="title">Title</label>
                                    <input type="text" id="title" value={template.title} onChange={handleTemplateEdit} name="title" className="block rounded-md border border-gray-300 w-full p-4 my-3 mt-2 font-medium" />
                                </div>
                                {errors.title && <div className="text-bloodred font-bold">{errors.title}</div>}
                            </div>
                            <div>
                                <label htmlFor="body">Body</label>
                                <textarea id="body" value={template.body} onChange={handleTemplateEdit} className="w-full mt-2 p-4 outline-none rounded-md border border-gray-300 min-h-[360px] max-h-[720px]">

                                </textarea>
                                {errors.text && <div className="text-bloodred font-bold">{errors.text}</div>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}